import './ListicleEvents.css';
import React from 'react';
import { parse } from 'node-html-parser';
import { get, getFormatedDate, getGlobalDictionaryTerm, getColorByTheme, canUseDOM, getPageThemeColors } from '../../utils';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import LazyPicture from '../atoms/LazyPicture';
import Video from '../atoms/Video';
import { commonStyles as commonComponentStyles, rtlStyles, ltrStyles } from '../77_ListicleItem/ListicleItem';
import { ReactComponent as IconLocation } from '../../resources/icons/ReskinIconPin.svg';
import { ReactComponent as IconCalendar } from '../../resources/icons/calendar.svg';
import RouterLink from '../atoms/RouterLink';
// import Truncate from 'react-truncate';
import { ReactComponent as IconChevronRightLight } from '../../resources/icons/IconChevronRightLight.svg';
import FavouriteBtn from '../atoms/FavouriteBtn/FavouriteBtn';
import { tealiumClickFunc, tealiumMergeClickData, getLastPartInURL } from '../../utils/tealium';
import { renderRTListSchema, getListsTexts } from '../../utils/seo';
import TruncateMarkup from 'react-truncate-markup';
import ReactHtmlParser from 'react-html-parser';
// import IconChevronLeftLight from '../../resources/icons/IconChevronLeftLight.svg';

export const ListicleEvents = _ref => {
  let {
    fields,
    index = 1,
    params
  } = _ref;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const businessSite = get(sitecoreContext, 'site.name') === 'business';
  const currentLang = get(sitecoreContext, 'language');
  const moduleId = get(fields, 'data.item.id');
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  const newWindowLabel = getGlobalDictionaryTerm(sitecoreContext, 'newWindowLabel') || "Opens in a new window";
  const infoRef = React.useRef(null);
  const [truncateWidth, settruncateWidth] = React.useState(1100);
  const enablingReadMore = get(fields, 'data.item.enablingReadMore.jss.value');
  const [isTruncated, setisTruncated] = React.useState(enablingReadMore);
  const dictionaryValues = get(fields, 'data.moduleDictionary.dictionaryValues') || [];
  const mapDictionary = dictionaryValues.reduce((map, currentValue) => map.set(currentValue.key.jss.value, currentValue.phrase.jss.value), new Map());
  const [isVdsite, setIsVdsite] = React.useState(true);
  const [componentListsSchema, setComponentListsSchema] = React.useState([]);
  React.useEffect(() => {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  React.useEffect(() => {
    if (truncateWidth < 769) {
      setisTruncated(true);
    }
  }, [truncateWidth]);
  const primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  const selectedPrimaryColor = primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary;
  const BackgroundColorHex = get(params, 'BackgroundColorHex');
  const ColorHex = get(params, 'ColorHex');
  const variables = ColorHex ? {
    "--m77-listicle-events-background-color": BackgroundColorHex,
    "--m77-listicle-events-color": ColorHex
  } : {
    "--m77-listicle-events-background-color": selectedPrimaryColor,
    "--m77-listicle-events-color": getColorByTheme(selectedPrimaryColor)
  };
  const {
    videoAnalytics,
    prevNextNavAnalytics,
    navBubblesAnalytics,
    readMoreAnalytics
  } = fields.data;
  const setWidth = () => {
    if (infoRef.current) {
      settruncateWidth(infoRef.current.offsetWidth);
    }
  };
  React.useEffect(() => {
    setTimeout(setWidth, 1000);
  }, [fields]);
  React.useEffect(() => {
    if (canUseDOM) {
      window.addEventListener("resize", setWidth);
    }
    return () => {
      if (canUseDOM) {
        window.addEventListener("resize", setWidth);
      }
    };
  }, []);
  const itemTitle = get(fields, 'data.item.title.jss.value');
  const favBtnItemId = get(fields, 'data.item.pOI.targetItem.id');
  const targetUrl = get(fields, 'data.item.url') || '/';
  const number = get(fields, 'data.item.number.jss');
  const hasFallbackImage = Boolean(get(fields, 'data.item.fallbackImage.jss.value.src'));
  const itemFallbackImage = get(fields, 'data.item.fallbackImage.jss.value.src');
  const itemFallbackImageCaption = get(fields, 'data.item.fallbackImage.jss.value.alt');
  const itemIntroText = Boolean(get(fields, 'data.item.introText.jss.value'));
  const itemCategory = get(fields, 'data.item.category.value.title.jss.value');
  // const hasVideoSrc: boolean = Boolean(get(fields, 'data.item.media.jss.value.href'));
  // const videoSrc = get(fields, 'data.item.media.jss.value.href');
  let videoSrc = get(fields, 'data.item.media.jss.value.href');
  const videoType = get(fields, 'data.item.media.jss.value.linktype');
  if (videoSrc === 'http://' || videoSrc === 'https://') {
    videoSrc = '';
  }
  const GooglePlaceID = get(fields, 'data.item.googlePlaceID.jss.value'); // eslint-disable-line
  const GooglePlaceLat = get(fields, 'data.item.latitude.jss.value');
  const GooglePlaceLong = get(fields, 'data.item.longitude.jss.value');
  const googleMapLatLongUrl = 'https://www.google.com/maps/search/?api=1&query=';
  const GooglePlace = googleMapLatLongUrl + GooglePlaceLat + ',' + GooglePlaceLong;
  const eventDateString = get(fields, 'data.item.eventDates.jss.value');
  const intro = get(fields, 'data.item.intro.jss');
  const address = get(fields, 'data.item.address.jss.value');
  const eventDates = Boolean(eventDateString) ? JSON.parse(eventDateString).dates : [];
  const eventItemDate = eventDates.map((date, index) => getFormatedDate(date, currentLang, true));
  React.useEffect(() => {
    const dom = intro ? parse(intro.value) : undefined;
    const rtLists = getListsTexts(dom);
    if (rtLists.length) setComponentListsSchema(rtLists);
  }, []);
  if (!fields) {
    console.info('ListicleItemEvent component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, "[ListicleItemEvent component is empty: please provide datasource]");
    }
    return null;
  }
  const renderMedia = () => {
    if (!hasFallbackImage) return null;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "listicle__media-outer"
    }, /*#__PURE__*/React.createElement("div", {
      className: "listicle__media-inner listicle__media-inner--poster-show"
    }, /*#__PURE__*/React.createElement(LazyPicture, {
      useEmptyPlaceholder: true,
      className: "listicle__image-box"
    }, /*#__PURE__*/React.createElement("source", {
      media: "(min-width:1200px)",
      srcSet: itemFallbackImage + '&cw=1420&ch=710'
    }), /*#__PURE__*/React.createElement("source", {
      media: "(min-width:769px)",
      srcSet: itemFallbackImage + '&cw=1180&ch=590'
    }), /*#__PURE__*/React.createElement("source", {
      media: "(max-width:768px)",
      srcSet: itemFallbackImage + '&cw=325&ch=243'
    }), /*#__PURE__*/React.createElement("img", {
      src: itemFallbackImage + '&cw=1420&ch=710',
      className: "listicle__img",
      alt: `${itemFallbackImageCaption}`
    })), videoSrc && /*#__PURE__*/React.createElement(Video, {
      buttonTopAlignment: true,
      className: "media-wrapper__video ",
      videoType: videoType,
      videoSrc: videoSrc,
      click: e => tealiumClickFunc(tealiumMergeClickData(videoAnalytics, params), [e, getLastPartInURL(videoSrc)])
    }), /*#__PURE__*/React.createElement(FavouriteBtn, {
      itemId: moduleId,
      classes: ' listicle__fav-btn'
    }))), /*#__PURE__*/React.createElement("div", {
      className: "listicle__caption body-small"
    }));
  };
  if (!fields.data.item) {
    return /*#__PURE__*/React.createElement("div", null);
  }
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    style: variables
  }, /*#__PURE__*/React.createElement("div", {
    className: "listicle__item"
  }, number && /*#__PURE__*/React.createElement(Text, {
    tag: "div",
    className: `listicle__tag ${businessSite ? 'listicle__tag--business' : ''}`,
    field: number,
    "data-cy": "number"
  }), itemIntroText && /*#__PURE__*/React.createElement(Text, {
    tag: "h2",
    className: "h2 listicle__title",
    field: fields.data.item.introText.jss,
    "data-cy": "listicle__title"
  }), /*#__PURE__*/React.createElement("div", {
    className: "listicle__media"
  }, renderMedia()), /*#__PURE__*/React.createElement("div", {
    className: `listicle__info ${!itemFallbackImageCaption ? 'listicle__info--no-caption' : ''}`
  }, /*#__PURE__*/React.createElement("div", {
    ref: infoRef,
    className: "listicle__info-text"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: `${truncateWidth}px`
    }
  }, isTruncated ? /*#__PURE__*/React.createElement("div", {
    className: "truncated-copy"
  }, /*#__PURE__*/React.createElement(TruncateMarkup, {
    lines: 3,
    ellipsis: /*#__PURE__*/React.createElement("span", {
      className: "read-more"
    }, `... `, /*#__PURE__*/React.createElement("b", {
      tabIndex: 0,
      onKeyPress: event => {
        if (event.key === "Enter" || event.key === "NumpadEnter") {
          event.preventDefault();
          event.target.click();
        }
      },
      onClick: () => {
        setisTruncated(false);
        tealiumClickFunc(tealiumMergeClickData(readMoreAnalytics, params), [getLastPartInURL(fields.data.item.introText.jss.value)]);
      },
      className: ""
    }, mapDictionary.get('ReadMore'), /*#__PURE__*/React.createElement(IconChevronRightLight, null)))
  }, /*#__PURE__*/React.createElement("div", null, ReactHtmlParser(intro && intro.value)))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, ReactHtmlParser(intro && intro.value)))))), /*#__PURE__*/React.createElement("div", {
    className: "listicle__bottom-info"
  }, itemTitle && /*#__PURE__*/React.createElement(RouterLink, {
    href: targetUrl,
    title: `${itemTitle}`,
    "data-cy": "listicle__item-link",
    className: "listicle__item-link body-large listicle__bottom-title"
  }, itemTitle), itemCategory && /*#__PURE__*/React.createElement("div", {
    className: "listicle__bottom-small"
  }, fields.data.item.category.value.title.jss.value), /*#__PURE__*/React.createElement("ul", {
    className: "listicle__list"
  }, eventDateString && /*#__PURE__*/React.createElement("li", {
    className: "listicle__list-item"
  }, /*#__PURE__*/React.createElement("div", {
    className: "listicle__list-icon"
  }, /*#__PURE__*/React.createElement(IconCalendar, null)), eventItemDate[0], eventItemDate[0] === eventItemDate[1] ? '' : ' - ' + eventItemDate[1]), address && /*#__PURE__*/React.createElement("li", {
    className: "listicle__list-item"
  }, GooglePlaceLat && GooglePlaceLong && GooglePlace ? /*#__PURE__*/React.createElement("a", {
    href: `${GooglePlace}`,
    target: "_blank",
    rel: "noopener noreferrer",
    title: `${address} | ${newWindowLabel}`
  }, /*#__PURE__*/React.createElement("div", {
    className: "listicle__list-icon"
  }, /*#__PURE__*/React.createElement(IconLocation, null)), /*#__PURE__*/React.createElement("span", {
    className: "listicle__tag-text"
  }, address)) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "listicle__list-icon"
  }, /*#__PURE__*/React.createElement(IconLocation, null)), /*#__PURE__*/React.createElement("span", {
    className: "listicle__tag-text"
  }, address))))))), componentListsSchema.map(listSchema => renderRTListSchema(listSchema)));
};
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl,
    anchorUrlParameter
  } = _ref2;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: `${commonComponentStyles} ${commonStyles} ${truncateStyles} ${rtl ? rtlStyles : ltrStyles}`
  }, children);
};
export const truncateStyles = "t1cvpp0g";
const commonStyles = "cl5y3rb";
export default ListicleEvents;